(() => {
 if (customElements.get('zr-stone-library')) return;
 class ZrStoneLibrary extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.abort = new AbortController();
   this.dialog = this.querySelector('dialog');
   this.panel = this.querySelector('[data-filters]');
   this.form = this.querySelector('[data-filter-form]');
   this.media = matchMedia('(min-width:990px)');
   this.dataset.enhanced = '';
   this.syncFilters = () => { if (this.panel) this.panel.open = this.media.matches; this.lockFilter(false); this.syncSheet(false); };
   this.syncFilters();
   this.media.addEventListener('change', this.syncFilters, {signal:this.abort.signal});
   this.addEventListener('click', e => this.onClick(e), {signal:this.abort.signal});
   this.addEventListener('change', e => this.onChange(e), {signal:this.abort.signal});
   this.form?.addEventListener('submit', e => {
    for(const input of this.form.querySelectorAll('input[type=number]')) if(input.value==='') input.disabled=true;
   }, {signal:this.abort.signal});
   this.panel?.addEventListener('toggle', () => {const open=this.panel.open&&!this.media.matches;this.lockFilter(open);this.syncSheet(open);}, {signal:this.abort.signal});
   this.addEventListener('keydown', e => {
    if(e.key==='Escape' && this.panel?.open && !this.media.matches) { this.closeFilters(); }
    if(e.key==='Tab' && this.panel?.open && !this.media.matches) {
     const nodes=[...this.panel.querySelector('.zr-stones__filter-panel').querySelectorAll('button,a,input,summary,[tabindex="0"]')].filter(n=>!n.disabled && n.getClientRects().length);
     const first=nodes[0],last=nodes[nodes.length-1];
     if(e.shiftKey&&document.activeElement===first){e.preventDefault();last?.focus();}
     else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first?.focus();}
    }
   }, {signal:this.abort.signal});
   this.setupSheetDrag();
   this.dialog.addEventListener('close',()=>this.cleanupDialog(),{signal:this.abort.signal});
   for(const a of this.querySelectorAll('.zr-stones__active a,.zr-stones__pagination a')) {
    const u=new URL(a.href,location.href);u.searchParams.set('view',this.dataset.view);a.href=u.href;
   }
  }
  disconnectedCallback(){this.abort?.abort();this.request?.abort();this.lockFilter(false);if(this.dialog?.open)this.dialog.close();}
  closeFilters(){
   const facets=this.querySelector('zr-stone-facets');
   if(facets?.ready)facets.applyFilters();
   this.panel.open=false;this.lockFilter(false);this.syncSheet(false);
   this.querySelector('[data-filters]>summary')?.focus({preventScroll:true});
  }
  syncSheet(open){
   const sheet=this.panel?.querySelector('.zr-stones__filter-panel');if(!sheet)return;
   if(!this.media.matches){sheet.setAttribute('role','dialog');sheet.setAttribute('aria-modal','true');}
   else{sheet.removeAttribute('role');sheet.removeAttribute('aria-modal');}
   if(open){sheet.querySelector('[data-close-filters]')?.focus({preventScroll:true});}
  }
  setupSheetDrag(){
   const grip=this.querySelector('[data-sheet-grip]'),sheet=this.panel?.querySelector('.zr-stones__filter-panel');if(!grip||!sheet)return;
   let start=null,delta=0;
   grip.addEventListener('pointerdown',e=>{if(this.media.matches||e.button!==0)return;start=e.clientY;delta=0;grip.setPointerCapture(e.pointerId);},{signal:this.abort.signal});
   grip.addEventListener('pointermove',e=>{if(start===null)return;delta=Math.max(0,e.clientY-start);sheet.style.transform='translateY('+delta+'px)';},{signal:this.abort.signal});
   const finish=e=>{if(start===null)return;start=null;sheet.style.removeProperty('transform');if(e.type==='pointerup'&&delta>60)this.closeFilters();};
   grip.addEventListener('pointerup',finish,{signal:this.abort.signal});
   grip.addEventListener('pointercancel',finish,{signal:this.abort.signal});
   grip.addEventListener('lostpointercapture',()=>{start=null;sheet.style.removeProperty('transform');},{signal:this.abort.signal});
  }
  lockFilter(lock){
   if(lock&&!this.filterLocked){this.oldOverflow=document.body.style.overflow;document.body.style.overflow='hidden';this.filterLocked=true;}
   if(!lock&&this.filterLocked){document.body.style.overflow=this.oldOverflow||'';this.filterLocked=false;}
  }
  onClick(e){
   const quick=e.target.closest('[data-quick-url]');
   if(quick){e.preventDefault();this.openQuick(quick);return;}
   if(e.target.closest('[data-close-quick]')) this.dialog.close();
   if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}
   if(e.target.closest('[data-close-filters]'))this.closeFilters();
  }
  onChange(e){
   if(e.target.matches('[data-sort-form] select')){e.target.form.requestSubmit();return;}
   if(e.target.matches('[data-variant-select]')){
    const option=e.target.selectedOptions[0],root=e.target.closest('[data-product-quick]'),button=root.querySelector('[data-add-button]');
    root.querySelector('[data-variant-price]').textContent=option.dataset.price;
    for(const row of root.querySelectorAll('[data-quick-field]')){const value=option.dataset[row.dataset.quickField]||'';row.querySelector('dd').textContent=value;row.hidden=!value;}
    const link=root.querySelector('.zr-stone-quick__details'),url=new URL(link.href);url.searchParams.set('variant',option.value);link.href=url.href;
    button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.soldLabel:button.dataset.addLabel;
   }
  }
  async openQuick(trigger){
   const url=new URL(trigger.dataset.quickUrl,location.href);
   if(url.origin!==location.origin)return;
   this.request?.abort();this.request=new AbortController();
   const content=this.querySelector('[data-quick-content]'),status=this.querySelector('[data-quick-status]'),fallback=this.querySelector('[data-quick-fallback]');
   this.returnFocus=trigger;content.replaceChildren();status.textContent=this.dataset.loading;fallback.hidden=true;fallback.href=url.href;
   this.dialog.showModal();
   url.searchParams.set('view','zr-stone-quick');
   const request=this.request;
   try{
    const response=await fetch(url,{signal:request.signal,credentials:'same-origin'});
    if(!response.ok)throw new Error('Unavailable');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html'),fragment=doc.querySelector('[data-product-quick]');
    if(!fragment)throw new Error('Missing view');
    if(request.signal.aborted)return;
    for(const script of fragment.querySelectorAll('script'))script.remove();
    content.replaceChildren(document.importNode(fragment,true));status.textContent='';
    const firstImage=content.querySelector('img');if(firstImage)firstImage.loading='eager';
   }catch(error){if(error.name==='AbortError')return;status.textContent=this.dataset.error;fallback.hidden=false;}
  }
  cleanupDialog(){
   this.request?.abort();
   for(const video of this.dialog.querySelectorAll('video'))video.pause();
   this.querySelector('[data-quick-content]').replaceChildren();
   this.returnFocus?.focus();
  }
 }
 customElements.define('zr-stone-library',ZrStoneLibrary);
})();

